const Facturacion = () => <div><h3>💳 Gestión de Facturación</h3></div>;
export default Facturacion;